import {Constructor} from "../../global/constructor";
import ObjectModelProperty from "../models/objectModelProperties/objectModelProperty";
import {Hash} from "../interfaces/hashInterfaces";
import {ObjectHelper} from "../helpers/objectHelper";

export default function ObjectModelPropertyContainer<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    id: string;
    client_id: string;
    object_model_properties: Hash<ObjectModelProperty> = {};
    saveChangesToStore: () => void;
    objectModelPropertiesById: Hash<ObjectModelProperty> = undefined;

    get hasProperties(): boolean {
      return Object.keys(this.object_model_properties).length > 0;
    }

    get objectModelPropertiesArray(): ObjectModelProperty[] {
      return ObjectHelper.toArray(this.object_model_properties)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    findPropertyById(id: string): ObjectModelProperty {
      if (this.objectModelPropertiesById === undefined) {
        this.objectModelPropertiesById = {};
        for (const prop of Object.values(this.object_model_properties)) {
          this.objectModelPropertiesById[prop.id] = prop;
        }
      }
      return this.objectModelPropertiesById[id];
    }

    findObjectModelProperty(clientIdOrId: string): ObjectModelProperty {
      let found = this.object_model_properties[clientIdOrId];
      if (found) return found
      found = this.findPropertyById(clientIdOrId);
      if (found) return found
      found = this.objectModelPropertiesArray.find(p => p.client_id === clientIdOrId || p.id === clientIdOrId);
      if (found) return found
      for (let prop of this.objectModelPropertiesArray) {
        if (prop.object_model_properties) {
          found = Object.values(prop.object_model_properties).find(p => p.client_id === clientIdOrId || p.id === clientIdOrId)
          if (found) return found
        }
      }
    }
  };
}